import { DirectionProvider } from '@radix-ui/react-direction';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense, type ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { Toaster } from 'sonner';

import { i18n } from '@/shared/i18n/i18n';

import { queryClient } from './query-client';

function RadixDirectionGate({ children }: { children: ReactNode }) {
  const { i18n: i18nInstance } = useTranslation();
  const dir = (i18nInstance.language || 'en').startsWith('ar') ? 'rtl' : 'ltr';
  return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <RadixDirectionGate>
          <QueryClientProvider client={queryClient}>
            <Suspense fallback={<div className="grid h-screen place-items-center">Loading…</div>}>
              {children}
            </Suspense>
            <Toaster richColors position="top-right" />
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />}
          </QueryClientProvider>
        </RadixDirectionGate>
      </I18nextProvider>
    </HelmetProvider>
  );
}
